<script setup lang="ts">
import { AccordionItem, type AccordionItemProps } from 'radix-vue'

const props = defineProps<AccordionItemProps>()
</script>

<template>
  <AccordionItem
    v-bind="props"
    class="c-accordion__item"
  >
    <slot />
  </AccordionItem>
</template>


<style scoped>
.c-accordion__item {
  border-bottom: 1px solid var(--theme-heading-color);
  padding-bottom: calc(var(--c-accordion-vertical-padding) - var(--c-accordion-vertical-gap));
}
</style>
